import IframeActivity from "./IframeActivity";

export default function LittlestTokyo() {
    return (
        <IframeActivity
            src="/activities/littlest-tokyo/index.html"
            title="Tokyo Scavenger Hunt"
            height="825"
        />
    );
}